import { FormattedMessage } from 'react-intl'
import React from 'react'

export function TransChoice({ count, id }) {
  if (parseInt(count) === 1) {
    return <FormattedMessage id={`${id}.zero`} />
  }
  return <FormattedMessage id={`${id}.one`} />
}
